<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/zhixin-logo3.png" alt="logo图">
    </div>
    <p class="title">&nbsp;</p>
    <p class="address_tel_fax">
      <span>地址：辽宁省大连市甘井子区汇达街17号18层4号</span>
      <span>Tel：13889665204</span>
    </p>
    <p class="email_wx">
      <span>邮箱：sunjian@zhixin-smart-tech.com</span>
      <span>微信号：ZXZH_SJ888</span>
    </p>
    <p class="copy">Copyright &copy; 2021 - {{ new Date().getFullYear() }} 公司名称</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /* background: #474747; */
  background : linear-gradient(#aaa,#222);
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.logo img {
  width : 95px;
  height : 95px;
  margin : auto;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue